export const regularRound = (num: number, dec: number = 0): number => {
  return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
};
